import React from 'react';

const TestCard = ({ test, destacado = false, onDescargar }) => {
  return (
    <div 
      className={`test-card ${destacado ? 'test-card-destacado' : ''} ${test.tipo === 'repaso' ? 'test-repaso' : 'test-general'}`} 
    >
      <div className="test-card-header">
        <div className="test-number">
          {destacado && <i className="fas fa-star test-star-icon"></i>}
          Test {test.numero_test}
        </div>
        <div className={`test-type-indicator ${test.tipo || 'general'}`}>
          {test.tipo === 'repaso' ? (
            <><i className="fas fa-sync-alt"></i> Repaso {test.tema && `(Tema ${test.tema})`}</>
          ) : (
            <><i className="fas fa-book"></i> General</>
          )}
        </div>
      </div>
      
      <div className="test-card-content">
        {test.descripcion && <p className="test-descripcion">{test.descripcion}</p>}
        
        {/* Información adicional según el tipo de test */}
        {test.tipo === 'repaso' && (
          <div className="test-info-extra">
            <div className="info-item">
              <i className="fas fa-bookmark"></i> Tema: {test.tema}
            </div>
            {test.vuelta && (
              <div className="info-item">
                <i className="fas fa-sync-alt"></i> Vuelta {test.vuelta}
              </div>
            )}
          </div>
        )}
        
        {test.tipo === 'general' && test.vuelta && (
          <div className="test-info-extra">
            <div className="info-item">
              <i className="fas fa-sync-alt"></i> Vuelta {test.vuelta}
            </div>
            <div className="info-item">
              <i className="fas fa-hashtag"></i> Test general {test.indice_mes - 3} de 4
            </div>
          </div>
        )}
      </div>
      
      <div className="test-card-footer">
        <button 
          className="test-download-btn" 
          onClick={(e) => {
            e.stopPropagation(); // Prevenir propagación del evento
            onDescargar(test);
          }}
        >
          <i className="fas fa-download"></i> Descargar
        </button>
      </div>
    </div>
  );
};

export default TestCard;